import { GlobalConfig } from "stores/wizard/config/staticConfigs/global";

export const globalConfig: GlobalConfig = {
  navigation: {
    defaultLob: "wizard-hotel-pwa-v2",
    activeLob: "wizard-hotel-pwa-v2",
  },
  packageWith3PP: false,
  useLastSearchForMultiLOB: false,
  heroImageSrc: "https://a.travel-assets.com/travel-assets-manager/cmct-2135/CA_Autumn_Canmore_1400x600.jpg",
  defaultDestination: "",
  defaultMultipleOrigin: undefined,
  defaultOrigin: "",
  defaultMultipleDestination: undefined,
  selectedProduct: "",
  halfWizard: false,
  destinationDropdownTypeahead: false,
  calendarFilterCarrierCode: "",
  showHeroMobile: false,
  collapsed: false,
  cobrandImageUrl: "",
  displayBiasedWizard: true,
  includeSingleLOBsWithinPackages: false,
};
